import { render, staticRenderFns } from "./StatisticsMarksTimeDepartmentIndex.vue?vue&type=template&id=d95b057a"
import script from "./StatisticsMarksTimeDepartmentIndex.vue?vue&type=script&lang=js"
export * from "./StatisticsMarksTimeDepartmentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports